export const ProfileModuleConsts = {
    RESET_PASSWORD_PAGE_TITLE: 'World of Sweets - Reset Password',
    ALPHA_NUMERIC: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d][A-Za-z\d!@#$%^&*()_+]{5,14}$/
}